import API from 'services/API/index';

export default function getAdminConfigList(type) {
  return API.request({
    method: 'GET',
    url: `/settings?objectType=${type}`,
  });
}
